import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
const serviceCategories = [{
  id: "cat-1",
  title: "Mobilità Accademica",
  description: "Supporto completo per studenti internazionali, dalla selezione dell'istituto alla gestione delle pratiche.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/academic_mobility_thumb.png",
  services: ["Pratiche Burocratiche", "Visti di Studio", "Gestione Immigrazione", "Supporto Mobilità"]
}, {
  id: "cat-2",
  title: "Visti per Studio",
  description: "Consulenza specializzata per l'ottenimento di visti studenteschi e conformità consolare.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/student_visa_thumb.png",
  services: ["Domanda Visto", "Documentazione Immigrazione", "Rinnovo Visto", "Consulenza Visa"]
}, {
  id: "cat-6",
  title: "Supporto Universitario",
  description: "Assistenza completa per pratiche universitarie e riconoscimento titoli.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/university_support_thumb.png",
  services: ["Iscrizioni Universitarie", "Documenti Accademici", "Gestione Pratiche Amministrative", "Riconoscimento Titoli Esteri"]
}];
export default function ThePropAdvantage() {
  return <section data-section-id="222922" id="programmi-di-supporto" className="bg-background text-foreground py-16 md:py-24 lg:py-32 border-y border-border overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        
        <div className="mb-12 md:mb-20 flex flex-col md:flex-row md:items-end justify-between gap-8">
          <div className="max-w-2xl">
            <h2 className="text-4xl md:text-5xl lg:text-7xl font-default font-bold uppercase tracking-tighter leading-none mb-6">
              Supporto <span className="text-ring">STUDENTI</span> & Istituti
            </h2>
            <p className="text-muted-foreground text-lg md:text-xl font-default max-w-xl">
              Soluzioni premium per la mobilità internazionale, progettate per connettere talenti globali con le eccellenze accademiche mondiali.
            </p>
          </div>
          </div>

        <div className="grid lg:grid-cols-12 gap-0 border border-border bg-card/20">
          
          <div className="lg:col-span-4 relative min-h-[400px] lg:min-h-[800px] border-b lg:border-b-0 lg:border-r border-border overflow-hidden group">
            <div className="absolute inset-0 bg-ring/5 opacity-0 group-hover:opacity-100 transition-opacity duration-700 z-10 pointer-events-none mix-blend-overlay"></div>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/world_immigration_student_campus_premium.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/world_immigration_student_campus_premium.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/world_immigration_student_campus_premium.png-wvc-sizes" alt="Studente internazionale in un campus universitario moderno" loading="lazy" className="absolute inset-0 w-full h-full object-cover filter grayscale contrast-125 group-hover:grayscale-0 transition-all duration-700" />
            <div className="absolute top-4 left-4 border border-background/20 bg-background/40 backdrop-blur-sm px-3 py-1 text-xs font-mono tracking-widest text-foreground z-20">
              GLOBAL.EDU_v4.0
            </div>
            <div className="absolute bottom-4 right-4 flex gap-2 z-20">
              <div className="size-2 bg-ring animate-pulse"></div>
              <div className="size-2 bg-border"></div>
              <div className="size-2 bg-border"></div>
            </div>
          </div>

          <div className="lg:col-span-8 p-6 md:p-8 lg:p-12 bg-background/50">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {serviceCategories.map((category, i) => <div key={category.id} data-index={i} className="bg-[#1F4962] text-white p-6 rounded-lg flex flex-col justify-between border border-white/10 shadow-lg h-full items-center text-center">
                  <div className="w-full flex flex-col h-full">
                    <div className="flex-1 flex flex-col justify-center items-center gap-4 mb-4">
                      <div className="w-full h-32 shrink-0 rounded-md overflow-hidden border border-white/20">
                        <img src={category.image} data-wvc-srcset={`${category.image}-wvc-srcset`} data-wvc-sizes={`${category.image}-wvc-sizes`} alt={category.title} loading="lazy" className="w-full h-full object-cover" />
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl font-bold uppercase tracking-tight mb-2">{category.title}</h3>
                        <p className="text-white/70 text-sm leading-relaxed mb-4">
                          {category.description}
                        </p>
                      </div>
                    </div>
                    
                    <div className="grid grid-cols-1 gap-2 mt-auto flex justify-center">
                      {category.services.map((service, idx) => <Button key={idx} variant="secondary" size="sm" className="bg-[#FFC829] text-primary hover:bg-white rounded-md text-[10px] md:text-xs font-semibold py-1 h-auto whitespace-normal text-center leading-tight">
                          {service}
                        </Button>)}
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
          
        </div>
      </div>
    </section>;
}